import { APP_CONFIG } from './config.js';

const validLanguageCodes = APP_CONFIG.VALID_LANGUAGE_CODES;

/** * Get preferred language from cookie */
export function getCurrentBrowserFirstValidLanguage() {
  // Get first 2 letters of browser language
  let browserLang = navigator.language.slice(0, 2); // Get first 2 letters of browser language
  return validLanguageCodes.includes(browserLang) ? browserLang : false;
}
